﻿export class Environment {

    static applicationUrl: string;

    private static _initialize = (() => {
        let body = document.getElementsByTagName("body")[0];
        if (typeof body !== "undefined") {
            Environment.applicationUrl = body.getAttribute("data-application-url");
        }
    })();
}